module.exports = __webpack_public_path__ + "static/img/fotografieok.813f907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontpage/fotografieok.jpg
// module id = dleZ
// module chunks = 1